import React from "react";
import { getAccentHex } from "@/components/resume-builder/templates/templateConfig";

/** A4/Letter page size picker — shared between the Advanced editor's sidebar
 * and Step 4 ("Review & Download") of the Guided Wizard. */
export default function PageSizeSelector({ draft, setDraft }) {
  return (
    <div className="glass-panel rounded-2xl p-4" data-testid="resume-page-size-panel">
      <p className="text-xs font-semibold text-slate-300 mb-2">Page Size (PDF/Word)</p>
      <div className="flex gap-2" data-testid="resume-page-size-selector">
        {["A4", "Letter"].map((size) => (
          <button
            key={size} onClick={() => setDraft({ ...draft, page_size: size })} data-testid={`resume-page-size-${size}`}
            className={`text-xs font-semibold px-3 py-1.5 rounded-full border transition-colors ${
              (draft.page_size || "A4") === size ? "text-white" : "text-slate-400 border-transparent hover:text-white"
            }`}
            style={(draft.page_size || "A4") === size ? { backgroundColor: `${getAccentHex(draft.template_color)}33`, borderColor: `${getAccentHex(draft.template_color)}80` } : {}}
          >
            {size}
          </button>
        ))}
      </div>
    </div>
  );
}
